import { ArchiveAnnotationsForm } from 'civil-status/view-models/archive-annotations-list';
import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';

export const transformDatasetArchiveAnnotations = (formValues: ArchiveAnnotationsForm): string => {
  const { ...otherValues } = formValues;

  const transformedFilters: OperationObject = {
    codiceAmbito: {
      value: otherValues.codiceAmbito || '',
      operation: Operation.EQUALS,
    },
    stato: {
      value: otherValues.state || '',
      operation: Operation.EQUALS,
    },
    formazioneDa: {
      value: otherValues.startDate?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    formazioneA: {
      value: otherValues.endDate?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    registrazioneDa: {
      value: otherValues.startDateRegistration?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    registrazioneA: {
      value: otherValues.endDateRegistration?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    registro: {
      value: otherValues.typeEvent || '',
      operation: Operation.EQUALS,
    },
    tipoAttoSecondario: {
      value: otherValues.practice || '',
      operation: Operation.EQUALS,
    },
    testoIntestazione: {
      value: otherValues.owners || '',
      operation: Operation.LIKE,
    },
    anno: {
      value: otherValues.year || '',
      operation: Operation.EQUALS,
    },
    parte: {
      value: otherValues.portion || '',
      operation: Operation.EQUALS,
    },
    serie: {
      value: otherValues.serie || '',
      operation: Operation.EQUALS,
    },
    volume: {
      value: otherValues.volume || '',
      operation: Operation.EQUALS,
    },
    numero: {
      value: otherValues.number || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersMapped: Order = {};

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
    page: formValues.page,
    rowsPerPage: formValues.rowsPerPage,
  })}`;
};
